import styled from 'styled-components';
import device from '../../mediaQueries';

const BaseRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const LogoRow = styled(BaseRow)`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${device.mobile`
    height: 100%;
  `}
  ${device.desktop`
    align-items: flex-start;
    margin: 6px 0 30px 0;
  `}
`;

const LeftColumn = styled(BaseRow)`
  display: flex;
  flex-direction: row;
  flex: 1;
  ${device.desktop`
    align-items: flex-end;
    margin-bottom: 3px;
  `}
`;

const CentralColumn = styled(BaseRow)`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const RightColumn = styled(BaseRow)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
`;

const NavigationRow = styled(BaseRow)`
  margin-top: ${({ marginTop }) => marginTop || '10px'};
  height: 20px;
`;

export { CentralColumn, LeftColumn, LogoRow, NavigationRow, RightColumn };
